import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import LoadingMore from '@src/mobile/components/LoadingMore';
import styles from './index.css';
import { Store } from '../store';
import Comment from '../Comment';
import { POSITION_MAIN } from '../constants';
import { getCommentById } from '../services';
import { getList } from '../utils';
import NoData from '../Nodata';
import Loading from '../Loading';
import ReplyBtn from '../ReplyBtn';

const List = ({ subjectId, replyId, allowComment }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { list, page, topIdList } = states;

    const [initDone, setInitDone] = useState(false);

    // 初始请求的被回复评论（如果有）和按热度排序的五条（最多）评论
    const initData = async () => {
        // 被回复的评论
        let replyItem = null;

        try {
            if (replyId) {
                // 如果有被回复评论id
                // 请求被回复评论的数据
                const res = await getCommentById({ commentId: replyId, subjectId });

                if (res && res.status === 200 && res.data) {
                    const { code, data } = res.data;

                    if (code === 200) {
                        replyItem = data;
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }

        // 初始的全部评论
        let list = [];

        // 获取按热度排序的五条评论
        const { list: hotList } = await getList({ subjectId, page: 1, pageSize: 5, sort: {} });

        // 如果可以获取按热度排序的五条评论
        if (hotList && Array.isArray(hotList) && hotList.length) {
            list = [...hotList];
        }

        // 如果可以获取被回复评论
        if (replyId && replyItem) {
            // 被回复评论和按热度排序的五条评论合并并去重
            list = [replyItem, ...list.filter(item => item.id !== replyId)];
        }

        // 如果初始的全部评论长度大于0
        if (list.length) {
            // 获取初始评论的id数组，用于之后去重
            const topIdList = list.map(item => item.id);

            changeStates({ list, topIdList });
        }
    };

    useEffect(() => {
        initData().finally(() => {
            setInitDone(true);
        });
    }, []);

    const control = async () => {
        let statusText = 'error';

        const { list: newList, current, pageSize, total } = await getList({ subjectId, page });

        if (newList && Array.isArray(newList)) {
            if (current * pageSize >= total) {
                statusText = 'end';
            } else {
                statusText = 'success';
            }

            const filterList = newList.filter(item => !topIdList.find(id => id === item.id));

            changeStates({ list: [...list, ...filterList], total, page: current + 1 });
        }

        return statusText;
    };

    return (
        <>
            {initDone ? (
                <div className={styles.wrap}>
                    <div className={styles.content}>
                        {list.length ? (
                            <>
                                <div className={styles.list}>
                                    {list.map(item => (
                                        <Comment
                                            key={item.id}
                                            content={item}
                                            position={POSITION_MAIN}
                                            allowComment={allowComment}
                                        />
                                    ))}
                                </div>
                                <LoadingMore control={control} />
                            </>
                        ) : (
                            <NoData />
                        )}
                    </div>
                    {allowComment ? <ReplyBtn subjectId={subjectId} /> : null}
                </div>
            ) : (
                <Loading />
            )}
        </>
    );
};

List.propTypes = {
    subjectId: PropTypes.string,
    replyId: PropTypes.string,
    allowComment: PropTypes.bool,
};

export default errorBoundary(List);
